import { CardUIExtension, ICardUIExtensionContext } from 'tessa/ui/cards';
import { Guid } from 'tessa/platform';
import { CdCardTypes } from 'src/cdScripts/Helpers/CdCardTypes';
import { CdGeneralDocumentationClientHelper } from 'src/cdScripts/Helpers/Cards/CdGeneralDocumentationClientHelper';
import { CdTaskTypes } from 'src/cdScripts/Helpers/CdTaskTypes';

export class CdTechnicalDocumentationTaskUIExtension extends CardUIExtension {

  private _disposer: Function | null = null;

  public async saving(context: ICardUIExtensionContext) {
    if (context.model == null ||
        context.model.card == null) {
      return;
    }
    if (!Guid.equals(context.model.card.typeId, CdCardTypes.TechnicalDocumentationTypeID)) {
      return;
    }
    let tasks = context.card.tasks;

    await CdGeneralDocumentationClientHelper.SignFilesAsync(context, tasks, [CdTaskTypes.PkSigningTypeID]);
  }


  public finalized() {
      // подчищаем за собой
      if (this._disposer) {
          this._disposer();
          this._disposer = null;
      }
  }
}